import { StageData } from '../../game/StageLoader';

export const stage01: StageData = {
  id: 'stage_01',
  name: 'ステージ1: 砂漠の前哨戦',
  nameEn: 'Desert Skirmish',
  description: '砂漠上空で敵戦闘機と地上砲台を撃破せよ',
  terrain: 'desert',
  totalEnemies: 7,
  enemies: [
    // 敵戦闘機（巡回）
    { type: 'fighter', pos: [ 1500,  600, -2000], ai: 'patrol' },
    { type: 'fighter', pos: [-1200,  500, -1800], ai: 'patrol' },
    { type: 'fighter', pos: [ 2000,  800,  1500], ai: 'patrol' },
    { type: 'fighter', pos: [-2500,  700,  2000], ai: 'aggressive' },
    // 地上砲台
    { type: 'turret',  pos: [  800,    0, -1200] },
    { type: 'turret',  pos: [-1000,    0,  1500] },
    { type: 'turret',  pos: [ 2200,    0,   600] },
  ],
};
